export const lightTheme = {
    background: '#E2E1DD',
    text: '#232323',
    overlay: 'overlay'
}
export const darkTheme = {
    background: '#232323',
    text: '#E2E1DD',
    overlay: 'none'
}